import uni from "../styles/univesal.module.css";
import { header, error, isValidEmail } from "./common";
import { useState } from "react";
import { VisitorData, VisitorDataConfig, VisitorDataConfigVal } from "../types";
import { LangIds, Languages, getLang } from "../langs/langs";

interface Props {
  lang: Languages;
  visitor: VisitorData;
  cfg: VisitorDataConfig;
  onConfirm: (visitor: VisitorData) => void;
  onRetake: () => void;
}

function Summary({lang, visitor, cfg, onRetake, onConfirm}: Props) {

  const [useFullname, setUseFullname] = useState<boolean>(visitor.givenNames === '' && visitor.surname === '');

  const [email, setEmail] = useState<string>(visitor.email);
  const [age, setAge] = useState<string>(visitor.age.toString());
  const [gender, setGender] = useState<string>(visitor.gender);
  const [givenNames, setGivenNames] = useState<string>(visitor.givenNames);
  const [surname, setSurname] = useState<string>(visitor.surname);
  const [fullname, setFullname] = useState<string>(visitor.fullname);
  const [address, setAddress] = useState<string>(visitor.address);
  const [dateOfBirth, setDateOfBirth] = useState<string>(visitor.dateOfBirth);
  const [personalNumber, setPersonalNumber] = useState<string>(visitor.personalNumber);
  const [citizenship, setCitizenship] = useState<string>(visitor.citizenship);
  const [nationality, setNationality] = useState<string>(visitor.nationality);
  const [docCountry, setDocCountry] = useState<string>(visitor.docCountry);
  const [docEdition, setDocEdition] = useState<string>(visitor.docEdition);
  const [docType, setDocType] = useState<string>(visitor.docType);
  const [docIssue, setDocIssue] = useState<string>(visitor.docIssue);
  const [docExpiry, setDocExpiry] = useState<string>(visitor.docExpiry);
  const [docNumber, setDocNumber] = useState<string>(visitor.docNumber);

  const [emailEmp, setEmailEmp] = useState<boolean>(false);
  const [ageEmp, setAgeEmp] = useState<boolean>(false);
  const [genderEmp, setGenderEmp] = useState<boolean>(false);
  const [givenNamesEmp, setGivenNamesEmp] = useState<boolean>(false);
  const [surnameEmp, setSurnameEmp] = useState<boolean>(false);
  const [fullnameEmp, setFullnameEmp] = useState<boolean>(false);
  const [addressEmp, setAddressEmp] = useState<boolean>(false);
  const [dateOfBirthEmp, setDateOfBirthEmp] = useState<boolean>(false);
  const [personalNumberEmp, setPersonalNumberEmp] = useState<boolean>(false);
  const [citizenshipEmp, setCitizenshipEmp] = useState<boolean>(false);
  const [nationalityEmp, setNationalityEmp] = useState<boolean>(false);
  const [docCountryEmp, setDocCountryEmp] = useState<boolean>(false);
  const [docEditionEmp, setDocEditionEmp] = useState<boolean>(false);
  const [docTypeEmp, setDocTypeEmp] = useState<boolean>(false);
  const [docIssueEmp, setDocIssueEmp] = useState<boolean>(false);
  const [docExpiryEmp, setDocExpiryEmp] = useState<boolean>(false);
  const [docNumberEmp, setDocNumberEmp] = useState<boolean>(false);

  const handleEmail = (e : any) => {
    setEmail(e.target.value);
    setEmailEmp(false);
  }

  const handleAge = (e : any) => {
    setAge(e.target.value);
    setAgeEmp(false);
  }

  const handleGender = (e : any) => {
    setGender(e.target.value);
    setGenderEmp(false);
  }

  const handleGivenNames = (e : any) => {
    setGivenNames(e.target.value);
    setGivenNamesEmp(false);
  }

  const handleSurname = (e : any) => {
    setSurname(e.target.value);
    setSurnameEmp(false);
  }

  const handleFullname = (e : any) => {
    setFullname(e.target.value);
    setFullnameEmp(false);
  }

  const handleAddress = (e : any) => {
    setAddress(e.target.value);
    setAddressEmp(false);
  }

  const handleDateOfBirth = (e : any) => {
    setDateOfBirth(e.target.value);
    setDateOfBirthEmp(false);
  }

  const handlePersonalNumber = (e : any) => {
    setPersonalNumber(e.target.value);
    setPersonalNumberEmp(false);
  }

  const handleCitizenship = (e : any) => {
    setCitizenship(e.target.value);
    setCitizenshipEmp(false);
  }

  const handleNationality = (e : any) => {
    setNationality(e.target.value);
    setNationalityEmp(false);
  }

  const handleDocCountry = (e : any) => {
    setDocCountry(e.target.value);
    setDocCountryEmp(false);
  }
  
  const handleDocEdition = (e : any) => {
    setDocEdition(e.target.value);
    setDocEditionEmp(false);
  }

  const handleDocType = (e : any) => {
    setDocType(e.target.value);
    setDocTypeEmp(false);
  }

  const handleDocIssue = (e : any) => {
    setDocIssue(e.target.value);
    setDocIssueEmp(false);
  }

  const handleDocExpiry = (e : any) => {
    setDocExpiry(e.target.value);
    setDocExpiryEmp(false);
  }

  const handleDocNumber = (e : any) => {
    setDocNumber(e.target.value);
    setDocNumberEmp(false);
  }

  const handleClick = () => {
    var err = false;
    var element: HTMLElement|null = null;

    if(cfg.cfgEmail === VisitorDataConfigVal.EDITABLE && !isValidEmail(email)){
      setEmailEmp(true);
      err = true;
      element = document.getElementById('emailSpacer');
    }
    if(cfg.cfgAge === VisitorDataConfigVal.EDITABLE && (isNaN(+age) || age === '')){
      setAgeEmp(true);
      err = true;
      element = document.getElementById('ageSpacer');
    }
    if(cfg.cfgGender === VisitorDataConfigVal.EDITABLE && gender === ''){
      setGenderEmp(true);
      err = true;
      element = document.getElementById('genderSpacer');
    }
    if(useFullname === false){
      if(cfg.cfgGivenNames === VisitorDataConfigVal.EDITABLE && givenNames === ''){
        setGivenNamesEmp(true);
        err = true;
        element = document.getElementById('givenNamesSpacer');
      }
      if(cfg.cfgSurname === VisitorDataConfigVal.EDITABLE && surname === ''){
        setSurnameEmp(true);
        err = true;
        element = document.getElementById('surnameSpacer');
      }
    } else {
      if(cfg.cfgFullname === VisitorDataConfigVal.EDITABLE && fullname === ''){
        setFullnameEmp(true);
        err = true;
        element = document.getElementById('fullnameSpacer');
      }
    }
    if(cfg.cfgAddress === VisitorDataConfigVal.EDITABLE && address === ''){
      setAddressEmp(true);
      err = true;
      element = document.getElementById('addressSpacer');
    }
    if(cfg.cfgDateOfBirth === VisitorDataConfigVal.EDITABLE && dateOfBirth === ''){
      setDateOfBirthEmp(true);
      err = true;
      element = document.getElementById('dateOfBirthSpacer');
    }
    if(cfg.cfgPersonalNumber === VisitorDataConfigVal.EDITABLE && personalNumber === ''){
      setPersonalNumberEmp(true);
      err = true;
      element = document.getElementById('personalNumberSpacer');
    }
    if(cfg.cfgCitizenship === VisitorDataConfigVal.EDITABLE && citizenship === ''){
      setCitizenshipEmp(true);
      err = true;
      element = document.getElementById('citizenshipSpacer');
    }
    if(cfg.cfgNationality === VisitorDataConfigVal.EDITABLE && nationality === ''){
      setNationalityEmp(true);
      err = true;
      element = document.getElementById('nationalitySpacer');
    }
    if(cfg.cfgDocCountry === VisitorDataConfigVal.EDITABLE && docCountry === ''){
      setDocCountryEmp(true);
      err = true;
      element = document.getElementById('docCountrySpacer');
    }
    if(cfg.cfgDocEdition === VisitorDataConfigVal.EDITABLE && docEdition === ''){
      setDocEditionEmp(true);
      err = true;
      element = document.getElementById('docEditionSpacer');
    }
    if(cfg.cfgDocType === VisitorDataConfigVal.EDITABLE && docType === ''){
      setDocTypeEmp(true);
      err = true;
      element = document.getElementById('docTypeSpacer');
    }
    if(cfg.cfgDocIssue === VisitorDataConfigVal.EDITABLE && docIssue === ''){
      setDocIssueEmp(true);
      err = true;
      element = document.getElementById('docIssueSpacer');
    }
    if(cfg.cfgDocExpiry === VisitorDataConfigVal.EDITABLE && docExpiry === ''){
      setDocExpiryEmp(true);
      err = true;
      element = document.getElementById('docExpirySpacer');
    }
    if(cfg.cfgDocNumber === VisitorDataConfigVal.EDITABLE && docNumber === ''){
      setDocNumberEmp(true);
      err = true;
      element = document.getElementById('docNumberSpacer');
    }
    
    if(err){
      if(element)
        element.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" });
      return;
    }

    visitor.email = email;
    visitor.age = +age;
    visitor.gender = gender;
    visitor.givenNames = givenNames;
    visitor.surname = surname;
    visitor.fullname = fullname;
    visitor.address = address;
    visitor.dateOfBirth = dateOfBirth;
    visitor.personalNumber = personalNumber;
    visitor.citizenship = citizenship;
    visitor.nationality = nationality;
    visitor.docCountry = docCountry;
    visitor.docEdition = docEdition;
    visitor.docType = docType;
    visitor.docIssue = docIssue;
    visitor.docExpiry = docExpiry;
    visitor.docNumber = docNumber;
    
    onConfirm(visitor);
  }

  function addField(name: string, text: string, value: string, errMsg: string, handleFnc: (e : any) => void, emp: boolean, cfg: VisitorDataConfigVal){
    const nameSpacer = name + 'Spacer';
    if(cfg === VisitorDataConfigVal.EDITABLE)
    return (
      <>    
        <div className={uni.labelText}>{text}</div>
        <input type="text" name={name} id={name} onChange={handleFnc} className={emp ? uni.input_emp : uni.input} value={value}></input>
        {error(emp, errMsg)}
        <div className={uni.spacer} id={nameSpacer}/>
      </>
    );
    if(cfg === VisitorDataConfigVal.READ_ONLY)
      return (
        <>
          <div className={uni.labelText}>{text}</div>
          <div className={uni.mediumText}>{(value !== '') ? value : '-'}</div>
          <div className={uni.spacer} id={nameSpacer}/>
        </>
      );
    return (<></>);
  }

  function addNameFields(){
    if(useFullname === true){
      return addField('fullname', getLang(LangIds.SUMMARY_Fullname, lang), fullname, getLang(LangIds.SUMMARY_FullnameError, lang), handleFullname, fullnameEmp, cfg.cfgFullname);
    }else{
      return (
        <>
          {addField('givenNames', getLang(LangIds.SUMMARY_GivenNames, lang), givenNames, getLang(LangIds.SUMMARY_GivenNamesError, lang), handleGivenNames, givenNamesEmp, cfg.cfgGivenNames)}
          {addField('surname', getLang(LangIds.SUMMARY_Surname, lang), surname, getLang(LangIds.SUMMARY_SurnameError, lang), handleSurname, surnameEmp, cfg.cfgSurname)}
        </>
      );
    }
  }

  return (
    <>
      <div className={uni.containerFull}>
        {header(getLang(LangIds.SUMMARY_Header, lang), getLang(LangIds.SUMMARY_Headnum, lang))}
        <div className={uni.innerSmallCenterContainer}>
          <div className={uni.spacer}/>
          {addField('email', getLang(LangIds.SUMMARY_Email, lang), email, getLang(LangIds.SUMMARY_EmailError, lang), handleEmail, emailEmp, cfg.cfgEmail)}
          {addField('age', getLang(LangIds.SUMMARY_Age, lang), age, getLang(LangIds.SUMMARY_AgeError, lang), handleAge, ageEmp, cfg.cfgAge)}
          {addField('gender', getLang(LangIds.SUMMARY_Gender, lang), gender, getLang(LangIds.SUMMARY_GenderError, lang), handleGender, genderEmp, cfg.cfgGender)}
          {addNameFields()}
          {addField('address', getLang(LangIds.SUMMARY_Address, lang), address, getLang(LangIds.SUMMARY_AddressError, lang), handleAddress, addressEmp, cfg.cfgAddress)}
          {addField('dateOfBirth', getLang(LangIds.SUMMARY_DateOfBirth, lang), dateOfBirth, getLang(LangIds.SUMMARY_DateOfBirthError, lang), handleDateOfBirth, dateOfBirthEmp, cfg.cfgDateOfBirth)}
          {addField('personalNumber', getLang(LangIds.SUMMARY_PersonalNumber, lang), personalNumber, getLang(LangIds.SUMMARY_PersonalNumberError, lang), handlePersonalNumber, personalNumberEmp, cfg.cfgPersonalNumber)}
          {addField('citizenship', getLang(LangIds.SUMMARY_Citizenship, lang), citizenship, getLang(LangIds.SUMMARY_CitizenshipError, lang), handleCitizenship, citizenshipEmp, cfg.cfgCitizenship)}
          {addField('nationality', getLang(LangIds.SUMMARY_Nationality, lang), nationality, getLang(LangIds.SUMMARY_NationalityError, lang), handleNationality, nationalityEmp, cfg.cfgNationality)}
          {addField('docCountry', getLang(LangIds.SUMMARY_DocCountry, lang), docCountry, getLang(LangIds.SUMMARY_DocCountryError, lang), handleDocCountry, docCountryEmp, cfg.cfgDocCountry)}
          {addField('docEdition', getLang(LangIds.SUMMARY_DocEdition, lang), docEdition, getLang(LangIds.SUMMARY_DocEditionError, lang), handleDocEdition, docEditionEmp, cfg.cfgDocEdition)}
          {addField('docType', getLang(LangIds.SUMMARY_DocType, lang), docType, getLang(LangIds.SUMMARY_DocTypeError, lang), handleDocType, docTypeEmp, cfg.cfgDocType)}
          {addField('docIssue', getLang(LangIds.SUMMARY_DocIssue, lang), docIssue, getLang(LangIds.SUMMARY_DocIssueError, lang), handleDocIssue, docIssueEmp, cfg.cfgDocIssue)}
          {addField('docExpiry', getLang(LangIds.SUMMARY_DocExpiry, lang), docExpiry, getLang(LangIds.SUMMARY_DocExpiryError, lang), handleDocExpiry, docExpiryEmp, cfg.cfgDocExpiry)}
          {addField('docNumber', getLang(LangIds.SUMMARY_DocNumber, lang), docNumber, getLang(LangIds.SUMMARY_DocNumberError, lang), handleDocNumber, docNumberEmp, cfg.cfgDocNumber)}
          <div className={uni.spacer}/>
          <button className={uni.blankButton} type="button" onClick={onRetake}>{getLang(LangIds.SUMMARY_Retake, lang)}</button>
          <div className={uni.spacerSmall}/>
          <button className={uni.button} type="button" onClick={handleClick}>{getLang(LangIds.BUTTON_Continue, lang)}</button>
          <div className={uni.spacer}/>
        </div>
      </div>
    </>
  );
}

export default Summary;
